// src/utils/trackingData.js

/**
 * Obtiene el valor de una cookie por su nombre.
 */
export const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
};

/**
 * Obtiene, guarda y retorna los datos de seguimiento (Cookies y UTMs).
 * Utiliza sessionStorage para recordar los parámetros UTM y la landing page
 * durante la navegación del usuario en la tienda.
 */
export const getTrackingData = () => {
    const urlParams = new URLSearchParams(window.location.search);
    
    // Obtener los UTMs desde la URL o desde el sessionStorage si ya fueron guardados
    const utm_source = urlParams.get('utm_source') || sessionStorage.getItem('utm_source') || null;
    const utm_medium = urlParams.get('utm_medium') || sessionStorage.getItem('utm_medium') || null;
    const utm_campaign = urlParams.get('utm_campaign') || sessionStorage.getItem('utm_campaign') || null;
    const utm_content = urlParams.get('utm_content') || sessionStorage.getItem('utm_content') || null;

    // Guardar en sessionStorage para que persistan si el usuario navega a otras páginas antes de comprar
    if (urlParams.get('utm_source')) sessionStorage.setItem('utm_source', urlParams.get('utm_source'));
    if (urlParams.get('utm_medium')) sessionStorage.setItem('utm_medium', urlParams.get('utm_medium'));
    if (urlParams.get('utm_campaign')) sessionStorage.setItem('utm_campaign', urlParams.get('utm_campaign'));
    if (urlParams.get('utm_content')) sessionStorage.setItem('utm_content', urlParams.get('utm_content'));

    // Guardar la página de destino (landing page) la primera vez que entra a la web
    let landing_page = sessionStorage.getItem('landing_page');
    if (!landing_page) {
        landing_page = window.location.href;
        sessionStorage.setItem('landing_page', landing_page);
    }

    // Generar un ID único para el evento, útil para deduplicación en la API de Conversiones
    const metaEventId = 'evt_' + Date.now() + '_' + Math.random().toString(36).substring(2, 9);

    return {
        fbp: getCookie('_fbp') || null,
        fbc: getCookie('_fbc') || null,
        landingPage: landing_page,
        eventSourceUrl: window.location.href, // La URL exacta donde se genera el pedido
        utmSource: utm_source,
        utmMedium: utm_medium,
        utmCampaign: utm_campaign,
        utmContent: utm_content,
        metaPurchaseSent: false,
        metaPurchaseSentAt: null,
        metaEventId: metaEventId
    };
};
